module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-745975d400e3d772be83ad6fedb02087.svg&quot;;"